import { TableCell, TableRow } from "@mui/material";
import { GlobalClassKeys } from "assets/jss/common-styles";
import MuiLink from "components/MuiExtras/MuiLink";
import UsernameInspect from "components/UsernameInspect";
import UserProfileImageLink from "components/UserProfileImageLink";
import { DashboardUserModel } from "models/ApiModels";
import * as React from "react";
import Session from "services/Session";


export interface RenderUserModelListEvents {
    onSelectUser?: (userId: string, name: string, thumbnailUrl: string) => void;
}

interface IRenderUserModelList extends RenderUserModelListEvents {
    indexOffset: number;
    items: DashboardUserModel[];
    showDrillColumn?: boolean;
    onDrillDown?: (item: DashboardUserModel) => void;
}

export const RenderUserModelList: React.FC<IRenderUserModelList> = (props) => {
    
    return (
        <>
            {
                props.items.map((v, index) => {

                    var tdClassname = v.userId == Session.user.id
                        ? GlobalClassKeys.bold
                        : null
                        ;

                    return (
                        <TableRow key={index}>

                            <TableCell className={GlobalClassKeys.bold} style={{ width: 1 }}>
                                {props.indexOffset + index + 1}
                            </TableCell>

                            <TableCell className={tdClassname} style={{ width: 1 }}>
                                <UserProfileImageLink user={v} />
                            </TableCell>

                            <TableCell className={tdClassname}>
                                {
                                    props.onSelectUser
                                        ? <MuiLink color="secondary" onClick={() => props.onSelectUser(v.userId, v.name, v.thumbnailUrl)}><UsernameInspect user={v} /></MuiLink>
                                        : <UsernameInspect user={v} />
                                }
                            </TableCell>

                            {
                                v.total != null && props.showDrillColumn &&
                                <TableCell className={tdClassname} align="right">
                                    {
                                        props.onDrillDown
                                            ? <MuiLink color="secondary" onClick={() => props.onDrillDown(v)}>{v.total.toLocaleString()}</MuiLink>
                                            : v.total.toLocaleString()
                                    }
                                </TableCell>
                            }
                        </TableRow>
                    );
                })
            }
        </>
    );
}

RenderUserModelList.defaultProps = {
    showDrillColumn: true
}